import { Paginated } from '@mi-front/core';

/**
 * Generic interface for API responses that follow the standard pagination structure
 */
export interface GetManyResponseDto<T> {
  data: T[];
  count: number;
  total: number;
  page: number;
  pageCount: number;
}

/**
 * Converts any API response that follows the GetMany*ResponseDto pattern to the required Paginated format
 * @param response - The API response with data, count, total, page, and pageCount properties
 * @returns The converted response in Paginated<T> format
 */
export async function convertGetManyResponse<T>(
  responseOrPromise: GetManyResponseDto<T> | Promise<GetManyResponseDto<T>>,
): Promise<Paginated<T>> {
  const response = await responseOrPromise;

  return {
    results: response.data,
    metadata: {
      pageIndex: response.page - 1, // Convert from 1-based to 0-based indexing
      pagesCount: response.pageCount,
      showCount: response.count,
      totalCount: response.total,
    },
  };
}
